export default {"src":"/_next/static/media/search-icon-white.29bb1607.svg","height":16,"width":16};